import { call, all, takeLatest, put, select } from 'redux-saga/effects';

import { selectOffset, selectRailyatriId, selectUrlData, selectType, selectBugText, selectFeedbackText, selectImagesBug, selectImagesFeedback } from './train.selector';
import {
    detailsFetchFail,
    detailsFetchSuccess,
    sendPostFail,
    sendPostSuccess
} from './train.action';
import trainActionTypes from './train.types';

export function* onSentPostStart() {
    try {
        const type = yield select(selectType);
        const railyatriId = yield select(selectRailyatriId)
        const bugText = yield select(selectBugText);
        const feedbackText = yield select(selectFeedbackText);
        const urlData = yield select(selectUrlData);
        const queryString = require('querystring-es3');
        const parsed = queryString.parse(urlData);
        const deviceInfo = urlData;
        const imageBug = yield select(selectImagesBug);
        const imageFeedback = yield select(selectImagesFeedback);
        console.log(type)
        var request = {
            type: type, content: bugText, user_id: railyatriId, deviceInfo: deviceInfo,image:imageBug
        }
        if (type == 2) {
            var request = {
                type: type, content: feedbackText, user_id: railyatriId, deviceInfo: deviceInfo,image:imageFeedback
            }
        }
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(request),
            headers: new Headers({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            })
        };
        const url = 'https://assistedbooking-stage.railyatri.in/TtbSupportApi/CreateFeedbackorBug';
        const res = yield call(fetch, url, requestOptions);
        const data = yield res.json();
        if (data.status === true && data.message === 'Data created') {
            yield put(sendPostSuccess(data))
        } else {
            yield put(sendPostSuccess([]))
            yield put(sendPostFail(data))
        }
    } catch (error) {
        yield put(sendPostFail(error))
    }
}

export function* SentPostStart() {
    yield takeLatest(trainActionTypes.SEND_POST_START, onSentPostStart)
}

export function* onDetailsFetch() {
    try {
        const railyatriId = yield select(selectRailyatriId);
        const urlData = yield select(selectUrlData);
        const queryString = require('querystring-es3');
        const parsed = queryString.parse(urlData);
        const offSet = yield select(selectOffset);
        const url = "https://assistedbooking-stage.railyatri.in/index.php/TtbSupportApi/Details/id/" + railyatriId + '/authentication_token/' + parsed.authentication_token + '/limit/' + offSet;
        const res = yield call(fetch, url);
        const details = yield res.json();
        if (details.success === 200 && details.status === true) {
            yield put(detailsFetchSuccess(details.result));
        } else {
            yield put(detailsFetchSuccess([]));
            yield put(detailsFetchFail(details));
            yield window.location.href = '/ttbhelp/unknown';
        }
    } catch (error) {
        yield put(detailsFetchFail(error));
    }
}

export function* DetailsFetchStart() {
    yield takeLatest(trainActionTypes.DETAILS_FETCH_START, onDetailsFetch)
    yield takeLatest(trainActionTypes.SET_OFFSET, onDetailsFetch)
}

export function* trainSaga() {
    yield all([
        call(DetailsFetchStart),
        call(SentPostStart)
    ])
}